var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15.5C30 7.21578 23.2842 0.5 15 0.5C6.71578 0.5 0 7.21566 0 15.5C0 22.9869 5.48531 29.1925 12.6562 30.3178V19.8359H8.84766V15.5H12.6562V12.1953C12.6562 8.43594 14.8957 6.35938 18.3219 6.35938C19.9631 6.35938 21.6797 6.65234 21.6797 6.65234V10.3438H19.7883C17.9248 10.3438 17.3438 11.5 17.3438 12.6863V15.5H21.5039L20.8389 19.8359H17.3438V30.3178C24.5147 29.1925 30 22.987 30 15.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 19.8359L21.5039 15.5H17.3438V12.6863C17.3438 11.4999 17.9249 10.3438 19.7883 10.3438H21.6797V6.65234C21.6797 6.65234 19.9631 6.35938 18.3219 6.35938C14.8957 6.35938 12.6562 8.43594 12.6562 12.1953V15.5H8.84766V19.8359H12.6562V30.3178C13.4316 30.4393 14.2152 30.5002 15 30.5C15.7848 30.5002 16.5684 30.4393 17.3438 30.3178V19.8359H20.8389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.effd7158dc1ec993a70f1425554b0cf3.svg";
export { ForwardRef as ReactComponent };